export default class ShowCancelledActivityController {
  /** @ngInject */
  constructor(
    $log, $mdDialog,
    moment,
    SubstitutionService,
    UtilService,
    cancelledActivity
  ) {
    this.$log = $log;
    this.$mdDialog = $mdDialog;
    this.moment = moment;
    this.SubstitutionService = SubstitutionService;
    this.UtilService = UtilService;
    this.cancelledActivity = cancelledActivity;

    this.date = this.moment(this.cancelledActivity.date).toDate();
    if (this.cancelledActivity.startTime) {
      this.startTime = this.moment(this.UtilService.parseTime(this.cancelledActivity.startTime)).format('HH:mm');
    }

    if (this.cancelledActivity.endTime) {
      this.endTime = this.moment(this.UtilService.parseTime(this.cancelledActivity.endTime)).format('HH:mm');
    }
  }

  cancel() {
    this.$mdDialog.cancel();
  }
}
